/*@flow*/
import findScrollContainer from 'lib/findScrollContainer';

export default (currentTarget: HTMLElement, opts: { jump?: boolean } = {}) => {
  const drawer = findScrollContainer(currentTarget);

  if (drawer instanceof HTMLElement) {
    if (opts.jump) {
      $(drawer).scrollTop(0);
    } else {
      $(drawer)
        .stop()
        .animate({ scrollTop: 0 }, 200, 'swing');
    }
  } else {
    process.env.NODE_ENV !== 'test' && $(document).scrollTop(0);
  }
};
